import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    if (!window.picflow) {
      window.picflow = !0;
      var s = document.createElement("script");
      s.src = "https://picflow.com/embed/main.js";
      s.type = "module";
      s.defer = true;
      document.head.appendChild(s);
    }
  }
}
